import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Container, Grid, Typography } from "@mui/material";
import { ObjectsWrapper } from "./objectsWrapper";
import { t } from "@lingui/core/macro";
import { useEffect, useState } from "react";
import { getSelectedTaxonomyIds } from "../../helpers/taxonomyHelpers";
import { usePostQuery } from "../../hooks/usePostQuery";
import { Loader } from "../loader";
import { CustomConsistencyCheckColumns, CustomConsistencyError, ConsistencyLabel, ISelectTemplate } from "../../api/customObjectsTypes";
import CustomObjectsDialog from "./customObjectsDialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
export const ConsistencyCheck = () => {

    const [callApi, setCallApi] = useState(false);
    const [cacheBuster, setCacheBuster] = useState(crypto.randomUUID());

    const taxonomies = getSelectedTaxonomyIds();

    const [req, setReq] = useState({});

    const [selectedId, setSelectedId] = useState<string | undefined>(undefined);

    const [rowType, SetRowType] = useState<string | ISelectTemplate | undefined>(undefined);

    useEffect(() => {
        setReq(taxonomies);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { data, loading } = usePostQuery<CustomConsistencyCheckColumns>(
        `api/custom-objects/consistency-check?taxonomiesToCheck=${taxonomies}&cb=${cacheBuster}`,
        req,
        !callApi
    );
    const handleCheck = () => {
        setCallApi(!callApi);
        setCacheBuster(crypto.randomUUID());
    };

    const handleCloseDialog = () => {
        setSelectedId(undefined);
    }

    const getTemplate = (entity: string | undefined) => {
        const usableEntity = entity?.toLowerCase()
        switch (usableEntity) {
            case "customlabel":
                return "labels";
            case "customtags":
                return "tags";
            case "customheader":
                return "headers";
            case "customdimension":
                return "customDimensions";
            case "customdimensionvalue":
                return "dimension-values";
            case "extensionelement":
                return "elements";
            case "customSettings":
                return "settings";
            default:
                return "header";
        }
    };

    return (
        <ObjectsWrapper>
            <Grid container maxWidth={"false"} alignItems="center" sx={{ p: 2 }}>
                <Grid size={6}>
                    <Typography variant="h5" fontWeight={"bold"} sx={{ pl: 2, pb: 2, pt: 2 }}>
                        {t`Consistency Check`}
                    </Typography>
                </Grid>
                <Grid size={6} container justifyContent="flex-end">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCheck}
                    >
                        {t`Check`}
                    </Button>
                </Grid>
            </Grid>
            {(selectedId !== undefined && rowType !== undefined) && (
                <CustomObjectsDialog
                    id={selectedId}
                    url={rowType}
                    open={selectedId !== undefined}
                    onClose={handleCloseDialog}
                    selectTemplate={rowType as ISelectTemplate}
                />
            )}
            <Container
                maxWidth={false}
                sx={{
                    minHeight: 750,
                    overflowY: 'auto',
                }}
            >
                {!data && !loading && (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 750 }}>
                        <Typography>
                            {t`Currently there are no results to display.`}
                        </Typography>
                    </Box>
                )}
                {loading && !data && (
                    <Loader
                        height={750}
                    />
                )}
                {Array.isArray(data) && (
                    <Box>
                        {data?.map((item: any) => (
                            <Box key={item.id} sx={{ mb: 3 }}>
                                <Accordion defaultExpanded>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="h4" fontWeight={"bold"}>
                                            {item.taxonomyName}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {[
                                            { key: 'customLabels', title: t`Custom Labels` },
                                            { key: 'customHeaders', title: t`Custom Header` },
                                            { key: 'customTags', title: t`Custom Tags` },
                                            { key: 'customSettings', title: t`Custom Settings` },
                                            { key: 'customDimension', title: t`Custom Dimension` },
                                            { key: 'customDimensionValue', title: t`Custom Dimension Value` },
                                            { key: 'customExtensionElement', title: t`Custom Extension Element` },
                                        ].map(({ key, title }) => (
                                            item[key] && (
                                                <Box key={key} sx={{ overflow: 'auto', borderRadius: 2, p: 2, mt: 5 }}>
                                                    <Typography variant="h5" fontWeight={"bold"}>{title}</Typography>
                                                    {item[key].map((column: ConsistencyLabel) => (
                                                        <Box key={column?.id} sx={{ pt: 2 }}>
                                                            <Typography
                                                                variant="subtitle1"
                                                                onClick={() => {
                                                                    setSelectedId(column?.id);
                                                                    SetRowType(getTemplate(column?.entity));
                                                                }}
                                                                sx={{
                                                                    cursor: 'pointer',
                                                                    textDecoration: 'underline',
                                                                    color: 'primary.main'
                                                                }}
                                                            >
                                                                {column?.name}
                                                            </Typography>
                                                            {column?.errors && column.errors.map((error: CustomConsistencyError) => (
                                                                <Box key={error.id} sx={{ pl: 2, pt: 1 }}>
                                                                    <Typography variant="body1"
                                                                        sx={{
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'underline',
                                                                            color: 'primary.main'
                                                                        }}
                                                                        onClick={() => {
                                                                            setSelectedId(error?.id);
                                                                            SetRowType(getTemplate(error?.entity));
                                                                        }}
                                                                    >
                                                                        {error.name}
                                                                    </Typography>
                                                                    <Typography variant="body2">
                                                                        {error.message}
                                                                    </Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    ))}
                                                </Box>
                                            )
                                        ))}
                                    </AccordionDetails>
                                </Accordion>
                            </Box>
                        ))
                        }
                    </Box>
                )}
            </Container >
        </ObjectsWrapper >
    );
}
